export const ACTION_CONSTS = {
  SET_TOKEN: 'SET_TOKEN',
};

export const STATE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
};
